class GoogleMapHelper {
	constructor() {
		this.googleMapIcon();
	}

	googleMapIcon(markerPointer, project = "0") {
		if (project === "1") {

			const googleMapIconProject =  {
				url: mcubeArgs.themeLink + "/svg/map-pointer-project.svg",
				scaledSize: new google.maps.Size(36, 53),
				anchor: new google.maps.Point(18, 53)
			};
			return googleMapIconProject;

		} else {

			if (!markerPointer) {
				markerPointer = mcubeArgs.themeLink + "/svg/map-pointer-default.svg";
			}
			const googleMapIcon = {
				url: markerPointer,
				scaledSize: new google.maps.Size(36, 46),
				anchor: new google.maps.Point(18, 46)
			};
			return googleMapIcon;

		}
	}
}